export const normalizeImageCsvUrl = (url?: string) => {
    if (!url || typeof url !== 'string') return '';
    let normalized = url.trim();
    if (!normalized) return '';
    normalized = normalized.split('#')[0].split('?')[0];
    if (normalized.includes('/photos/thumbs/')) {
        normalized = normalized.replace('/photos/thumbs/', '/photos/');
    }
    normalized = normalized.replace('https://insite-data.auav.com.au/DATA', 'https://insite-data2.auav.com.au');
    normalized = normalized.replace('https://insite-data.auav.com.au', 'https://insite-data2.auav.com.au');
    return normalized;
};

export const getDuplicateImageUrlIndexes = (rows: Array<{ url?: string }> = []) => {
    const seen = new Map<string, number[]>();
    rows.forEach((row, idx) => {
        const normalized = normalizeImageCsvUrl(row?.url);
        if (!normalized) {
            return;
        }
        const arr = seen.get(normalized) || [];
        arr.push(idx);
        seen.set(normalized, arr);
    });

    const duplicateIndexes = new Set<number>();
    seen.forEach((indexes) => {
        if (indexes.length > 1) {
            indexes.forEach((idx) => duplicateIndexes.add(idx));
        }
    });
    return duplicateIndexes;
};
